import PubSub from "underpub-js";

var SplashPageStyleThree = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-SplashPageStyleThree',
	};

	$.extend(true, this.options, options);

};

SplashPageStyleThree.prototype.init = function() {

	var self = this;

};

export default SplashPageStyleThree;
